import {I18nProvider as CoreI18nProvider} from '@sollapay/web-core';

import i18n from '../config';

import type {FC, PropsWithChildren} from 'react';

export const I18nProvider: FC<PropsWithChildren> = ({children}) => (
  <CoreI18nProvider i18n={i18n}>{children}</CoreI18nProvider>
);
